<template>
  <CommonPages id="about-us" :class="['about-us-page']" titlePrefix="About Us"
    :metaDescription="domainConfig?.['meta']?.des || 'Learn more about our novel translation platform'">

    <div class="about-us-page__content">
      <div class="about-us-page__title">
        About Us
      </div>
      <div class="about-us-page__description">
        <p>
          Welcome to {{ domainConfig?.siteName }}, your ultimate destination for discovering and enjoying AI-generated novels. Our mission is to revolutionize the way you experience storytelling by leveraging cutting-edge artificial intelligence technology.
        </p>

        <h3 class="about-us-section-title">Our Story</h3>
        <p>
          Founded in 2025, {{ domainConfig?.siteName }} was born from a passion for literature and a fascination with AI technology. We believe in the power of stories to inspire, entertain, and connect people from all walks of life. Our platform brings together the creativity of AI with the timeless art of storytelling.
        </p>

        <h3 class="about-us-section-title">What We Offer</h3>
        <p>
          At {{ domainConfig?.siteName }}, we offer a diverse collection of novels across various genres, all crafted by advanced AI algorithms. Whether you’re a fan of science fiction, romance, mystery, or fantasy, you'll find something to captivate your imagination.
        </p>

        <h3 class="about-us-section-title">Our Technology</h3>
        <p>
          Our AI technology analyzes countless literary works to understand narrative structures, character development, and stylistic elements. This allows us to create unique and engaging stories tailored to your preferences.
        </p>

        <h3 class="about-us-section-title">Our Community</h3>
        <p>
          We are more than just a reading platform; we are a community of book lovers and tech enthusiasts. Join us to share your thoughts, participate in discussions, and connect with fellow readers who share your passion for AI and literature.
        </p>

        <h3 class="about-us-section-title">Join Us</h3>
        <p>
          Dive into the future of storytelling with {{ domainConfig?.siteName }}. Explore our vast library, discover new narratives, and be part of a community that celebrates the fusion of technology and creativity.
        </p>

        <h3 class="about-us-section-title">Contact Us</h3>
        <p>
          We’d love to hear from you! If you have any questions, feedback, or suggestions, please reach out to us at {{ domainConfig?.IAMEMAIL }}.
        </p>
        <p>
          Thank you for being a part of our journey!
        </p>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/about.scss'

export default {
  name: 'AboutUs',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';
.about-us-section-title {
  color: #ffffff;
  font-size: rem(20);
  font-weight: 700;
  margin-top: rem(32);
  margin-bottom: rem(12);
}
</style>
